export default __webpack_public_path__ + "images/27612fde4d8b57e9c2ff00b76781e631.svg";